import React from 'react';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { ScreenRepairInfoDTO } from 'business/models/Models';

export const preSaveRepairScreen = async (
  exp: ExperimentDtoClient,
  showModal,
): Promise<ScreenRepairInfoDTO> => {
  const screenRepairInfo: ScreenRepairInfoDTO = new ScreenRepairInfoDTO({
    isScreenRepairEnabled: exp.screenRepairInfo.isScreenRepairEnabled,
    isScreenRepairRequiredByDefaultLot:
      exp.screenRepairInfo.isScreenRepairRequiredByDefaultLot,
    sceenId: exp.screenRepairInfo.sceenId,
    totalLayersUsingScreen: exp.screenRepairInfo.totalLayersUsingScreen,
    isOk: exp.screenRepairInfo.isOk,
    experimentInfo: exp.screenRepairInfo.experimentInfo,
  });

  if (
    screenRepairInfo.totalLayersUsingScreen >= 1 &&
    screenRepairInfo.isScreenRepairRequiredByDefaultLot
  ) {
    const expNames = Object.values(screenRepairInfo.experimentInfo);
    const heading = 'Screen Repair';
    const body = (
      <div id='screenrepairmodal-body-wrapper' className="w-[100%] min-[1300px]:h-[62.25vh] min-[1800px]:h-[48vh] flex flex-col gap-2">
        <div id='screenrepairmodal-description-container'className="w-[100%] h-[35%] text-[#5D5D5D] flex flex-col text-[0.875rem]">
          <div id='screenrepairmodal-description-main'>
            The wells and well ingredients belonging to any experiments that reference
            screen lots in this screen will be updated appropriately.
          </div>
          <div id='screenrepairmodal-description-note'>Please note :</div>
          <div id='screenrepairmodal-note-list-wrapper' className="w-[100%] flex flex-col">
            <div id='screenrepairmodal-note-item1' className="w-[100%] ml-[1.5%] flex flex-row">
              <div id='screenrepairmodal-note-item1-number' className="w-[4%]">1.</div>
              <div id='screenrepairmodal-note-item1-text' className="w-[96%]">
                Any old printouts will become obsolete once these changes are saved.
              </div>
            </div>
            <div id='screenrepairmodal-note-item2' className="w-[100%] ml-[1.5%] flex flex-row">
              <div id='screenrepairmodal-note-item2-number' className="w-[4%]">2.</div>
              <div id='screenrepairmodal-note-item2-text' className="w-[96%]">
                Experiments referencing this screen, but that did not use screen lot
                plates from this screen, will not be updated.
              </div>
            </div>
          </div>
        </div>
        <div id='screenrepairmodal-experimentlist-container' className="w-[100%] h-[50%] flex flex-col">
          <div id='screenrepairmodal-experimentlist-header' className="w-[100%] h-[12%] text-[0.875rem] text-[#5D5D5D] content-center">
            This screen is used in following experiments:
          </div>
          <div id='screenrepairmodal-experimentlist-table' className="w-[100%] h-[88%] flex flex-col border border-solid border-[#E0E0E0]">
            <div id='screenrepairmodal-experimentlist-tableheader' className="w-[100%] h-[16%] pl-[1%] text-[#1B1B1B] text-[0.75rem] font-bold bg-[#E0E0E0] content-center">
              Experiment Name
            </div>
            <div id='screenrepairmodal-experimentlist-scrollarea' className="w-[100%] h-[84%] pl-[1%] overflow-y-scroll">
              {expNames.map((expName) => (
                <div id={`screenrepairmodal-experimentlist-item-${expName}`}
                  key={`experimentUsingScreen-${expName}`}
                  className="w-[100%] h-[1.5rem] text-[0.75rem] text-[#414141] content-center"
                >
                  {expName}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div id='screenrepairmodal-confirmation-text' className="h-[5%] text-[#5D5D5D] text-[0.875rem] content-center">
          Do you want to continue?
        </div>
      </div>
    );
    if (await showModal(heading, body)) {
      screenRepairInfo.isOk = true;
      return screenRepairInfo;
    } else {
      screenRepairInfo.isOk = false;
      return screenRepairInfo;
    }
  } else {
    screenRepairInfo.isOk = true;
    return screenRepairInfo;
  }
};
